export default "__VITE_ASSET__7ed0d319__"